import Vue from "vue";

export default new Vue({
  data() {
    return {
      tree: []
    };
  },
  created() {},
  methods: {},
  computed: {}
});
